import { PreviewVisit } from '../../visit-daily-overview-diagram';
import { ManualReservationWarning } from './reservation-manual-date/manual-reservation-warning';
import { ReservationCalendar } from './reservation-calendar/reservation-calendar';
import { ReservationTimeline } from './ReservationTimeline';
import { useState } from 'react';
import { ReservationTimeSlots } from './reservation-time-slot/reservation-time-slots';

export const AutomaticReservation = ({ serviceIds }: { serviceIds: string | undefined }) => {
  const [previewVisit, setPreviewVisit] = useState<PreviewVisit>();

  return (
    <>
      <ReservationCalendar serviceIds={serviceIds} />
      <ManualReservationWarning />
      <ReservationTimeSlots
        serviceIds={serviceIds}
        previewVisit={previewVisit}
        setPreviewVisit={setPreviewVisit}
      />
      <ReservationTimeline previewVisit={previewVisit} setPreviewVisit={setPreviewVisit} />
    </>
  );
};
